import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileText, Plus, Save, Trash2, MessageSquareText } from "lucide-react";
import { http, formatApiError } from "../lib/api";

export const PLACEHOLDER_HINT = "Champs automatiques : {prénom}, {site}, {date} (remplacés pour chaque agent).";

export const TemplatePicker = ({ onPick, current = "" }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { http.get("/message-templates").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div data-testid="msg-template-picker">
      <div className="text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-1.5 flex items-center gap-1"><FileText className="h-3 w-3" />Messages types</div>
      <div className="flex flex-wrap gap-1.5">
        {items.map((t) => (
          <button key={t.id} type="button" data-testid={`msg-template-${t.id}`} onClick={() => (!current.trim() || current === t.content || window.confirm("Remplacer le texte déjà saisi par ce modèle ?")) && onPick(t.content)} title={t.content}
            className="px-2.5 py-1 rounded-md text-xs font-semibold bg-slate-100 hover:bg-sky-100 hover:text-sky-800 transition-colors">{t.title}</button>
        ))}
      </div>
    </div>
  );
};

export const MessageTemplatesSettings = () => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { http.get("/message-templates").then((r) => setItems(r.data.map((t) => ({ ...t, _k: t.id })))).catch(() => setItems([])); }, []);
  if (!items) return null;
  const upd = (i, k, val) => setItems(items.map((t, j) => (j === i ? { ...t, [k]: val } : t)));
  const incomplete = items.some((t) => !t.title.trim() || !t.content.trim());
  const save = async () => {
    setBusy(true);
    if (incomplete) { setBusy(false); return toast.error("Chaque modèle doit avoir un titre et un texte"); }
    try { setItems((await http.put("/settings/message-templates", { items })).data.map((t) => ({ ...t, _k: t.id }))); toast.success("Messages types enregistrés"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="msg-templates-settings" className="border border-slate-200 bg-white rounded-md p-6 space-y-4">
      <div className="flex items-center gap-2"><MessageSquareText className="h-5 w-5 text-sky-600" /><h3 className="font-display text-lg font-extrabold">Messagerie — messages types</h3></div>
      <p className="text-xs text-slate-500 -mt-2">Proposés en un clic dans « Message » (fiche agent) et « Message groupé ». {PLACEHOLDER_HINT}</p>
      {items.map((t, i) => (
        <div key={t._k} className="border border-slate-200 rounded-md p-3 space-y-2" data-testid={`msg-template-row-${i}`}>
          <div className="flex gap-2">
            <input data-testid={`msg-template-title-${i}`} className="flex-1 border border-slate-300 rounded-md px-3 py-2 text-sm font-semibold" maxLength={80} value={t.title} placeholder="Titre" onChange={(e) => upd(i, "title", e.target.value)} />
            <button type="button" data-testid={`msg-template-delete-${i}`} onClick={() => setItems(items.filter((_, j) => j !== i))} className="p-2 rounded hover:bg-rose-50" title="Supprimer"><Trash2 className="h-4 w-4 text-rose-600" /></button>
          </div>
          <textarea data-testid={`msg-template-content-${i}`} rows={3} maxLength={4000} className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm" value={t.content} placeholder="Texte du message…" onChange={(e) => upd(i, "content", e.target.value)} />
        </div>
      ))}
      <div className="flex justify-between">
        <button type="button" data-testid="msg-template-add" onClick={() => setItems([...items, { id: "", title: "", content: "", _k: `new-${Date.now()}` }])} className="inline-flex items-center gap-1.5 border border-slate-300 px-3 py-2 rounded-md text-sm font-semibold hover:bg-slate-50"><Plus className="h-4 w-4" />Nouveau modèle</button>
        <button type="button" data-testid="msg-template-save" onClick={save} disabled={busy} className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white px-4 py-2 rounded-md text-sm font-semibold disabled:opacity-60"><Save className="h-4 w-4" />Enregistrer</button>
      </div>
    </div>
  );
};
